const TOKEN_STORAGE_KEY = "chatpodgpt.jwt";

export type StoredToken = string;

const hasWindow = typeof window !== "undefined";

export function getStoredToken(): StoredToken | null {
  if (!hasWindow) return null;
  return window.localStorage.getItem(TOKEN_STORAGE_KEY);
}

export function setStoredToken(token: StoredToken) {
  if (!hasWindow) return;
  window.localStorage.setItem(TOKEN_STORAGE_KEY, token);
}

export function clearStoredToken() {
  if (!hasWindow) return;
  window.localStorage.removeItem(TOKEN_STORAGE_KEY);
}

export function hasStoredToken(): boolean {
  return getStoredToken() !== null;
}
